<template>
    <div class="m-infoAuth">
        <ul class="tips">
            <li>请认真填写，保证信息真实性，否则会导致认证失败</li>
        </ul>
        <el-form :model="infoForm"
                 :rules="infoFormRules"
                 class="info-form"
                 ref="infoForm"
                 label-width="100px"
                 status-icon>
            <el-form-item label="真实姓名" prop="name">
                <el-input v-model="infoForm.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idNum">
                <el-input v-model="infoForm.idNum" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <div class="btn-group">
                <el-button type="primary" @click="saveInfoForm">下一步</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import {Exp} from '@/config/constant'

    export default {
        props: ['initData'],
        data() {
            return {
                infoForm: {
                    name: '',
                    idNum: ''
                },
                infoFormRules: {
                    name: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'},
                        {min: 2, max: 50, message: this.$t('rule.lengthBetween', ['2', '20']), trigger: 'blur'}
                    ],
                    idNum: [
                        {required: true, message: '请输入身份证号码', trigger: 'blur'},
                        {pattern: Exp.idCard, message: this.$t('rule.idCardNo'), trigger: 'blur'}
                    ],
                },
            }
        },
        mounted() {
            if (this.initData) {
                this.infoForm.name = this.initData.inputName
                this.infoForm.idNum = this.initData.inputIDCardNumber
            }
        },
        methods: {
            saveInfoForm() {
                this.$refs['infoForm'].validate((valid) => {
                    if (!valid) return

                    this.$api.postRealNameBasic(this.infoForm).then(res => {
                        this.$emit('stepChange', 1)
                    })
                })
            },
        },
    }
</script>

<style lang="scss">
    .m-infoAuth {
        .info-form {
            padding-top: 10px;

            .el-form-item {
                padding-right: 50px;
            }
        }
    }
</style>
